import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import {getManagersApprovalReasonTranslationKeys, IManagersApprovalTranslations, MANAGERS_APPROVAL_REASONS} from "../../../../pages/manage-returns/rma-page/rma-types";
import FontBody2 from "../../../fonts/font-body2/font-body2";
import {FONT_COLOR} from "../../../fonts/font-props";
import IconSirenOnLight from "../../../icons/icon-siren-on-light/icon-siren-on-light";

/* The interface it used to ensure we use the correct type of property topIndicator in data-card.tsx */
export interface IDataCardIndicator{}

const DataCardOrderOutOfPolicyIndicator: React.FC<IDataCardIndicator> = () => {
    const { getTranslation } = useDashboardTranslation();
    const translationKeys = getManagersApprovalReasonTranslationKeys(MANAGERS_APPROVAL_REASONS.ORDER_OUT_OF_POLICY) as IManagersApprovalTranslations;
    
    return (
        <div className='data-card-indicator out-of-policy'>
            <IconSirenOnLight />
            <FontBody2 color={FONT_COLOR.PRIMARY3}>
                { translationKeys?.indicatorKey?.key && translationKeys?.indicatorKey?.scope &&
                  getTranslation(translationKeys.indicatorKey.key, translationKeys.indicatorKey.scope)
                }
            </FontBody2>
        </div>
    );
}

export default DataCardOrderOutOfPolicyIndicator;